import React from "react";
import { useFormContext, useController } from "react-hook-form";
import { Switch } from "./Switch";

export interface PaziaSwitchProps {
  name: string;
  label?: string;
  defaultValue?: boolean;
  className?: string;
  disabled?: boolean;
  onChange?: (val: boolean) => void;
}

export const PaziaSwitch = ({
  label,
  name,
  className,
  disabled,
  defaultValue,
  onChange,
}: PaziaSwitchProps): JSX.Element => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { field } = useController({
    name,
    control,
    defaultValue,
  });

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    field.onChange(e);
    if (onChange) onChange(e.target.checked);
  };
  const errorMessage =
    errors[name]?.type === "required" ? "To pole jest wymagane." : "";

  return (
    <>
      <Switch
        label={label}
        onChange={onChangeHandler}
        onBlur={field.onBlur}
        checked={Boolean(field.value)}
        disabled={disabled}
        name={field.name}
        className={className}
      />
      {errorMessage && (
        <p className="text-red-500 mt-1 text-sm">{errorMessage}</p>
      )}
    </>
  );
};
